<div edsGrid>
  <div edsGrid edsPadding [edsPaddingTop]="'xxl'">
    <div class="container" *ngIf="thumbnails$ | async as thumbnails">
      <div edsRow>
        <eds-title
          edsCol
          [columnNumbers]="{ s: 4, m: 6, l: 10 }"
          [title]="title"
          size="h3"
          [isLight]="true"
          edsSpacing="sm"
          theme="dark"
        ></eds-title>
        <eds-title
          edsCol
          [title]="subTitle"
          [columnNumbers]="{ s: 4, m: 6, l: 10 }"
          edsSpacing="sm"
          *ngIf="subTitle"
          size="h6"
          theme="basic"
          [isLight]="true"
          [level]="3"
        ></eds-title>
        <ng-container>
          <ng-container *ngFor="let thumbnail of thumbnails">
            <div edsCol [columnNumbers]="{ s: 4, m: 6, l: 4 }" edsSpacing="md">
              <eds-thumbnail
                [hasBorders]="true"
                [hasShadows]="true"
                [headingLevel]="2"
                [titleLink]="getDetailsLink(thumbnail)"
                [title]="thumbnail.dctermsTitle"
                [buttonText]="downloadButtonText"
                [isNewWindow]="true"
                [href]="thumbnail.pdfDownloadLink"
                [body]="getDescription(thumbnail.dctermsDescription)"
                [type]="thumbnail.fileExtension"
              >
              </eds-thumbnail>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
